<template>
  <div style="width: 30%">
    <button class="btn btn-primary ml-4" @click="rebuildCategories">
      Rebuild Categories in Frontend
    </button>
    <fieldset class="p-2 rounded border mt-2">
      <div v-if="Fetching === true">
        <a-spin></a-spin>
      </div>
      <div style="font-weight: bold;" v-if="Fetching === false">
        <p
          class="d-inline"
          style="color: #3782f3; text-decoration: underline; cursor: pointer;"
          @click="goToLastCategory"
        >
          {{
            getCategoryData.parentHID === "/"
              ? "All Categories"
              : getCategoryData.parentLabel
          }}
        </p>
        <p class="d-inline">
          >
          {{
            getCategoryData.label === "" && CurrentHID === "/"
              ? "All Categories"
              : getCategoryData.label
          }}
        </p>
      </div>
      <div class="mt-1">
        <div class="form-group">
          <label for="new-category">New category:</label>
          <input
            type="text"
            v-model="NewCategory"
            class="form-control"
            id="new-category"
          />
        </div>
        <div class="form-group">
          <label for="notes">Notes:</label>
          <input type="text" v-model="Notes" class="form-control" id="notes" />
        </div>
        <button
          class="btn btn-primary"
          @click="AddCategory"
          :disabled="Level > 2 || Fetching === true"
        >
          Submit
        </button>
      </div>
    </fieldset>
    <!-- Results -->
    <div class="p-2 border rounded mt-1 mb-3" v-if="Fetching === true">
      <a-spin></a-spin>
    </div>
    <div class="p-2 border rounded mt-1 mb-3" v-if="Fetching === false">
      <div v-for="Category in getCategoryResults" :key="Category.categoryID">
        <div class="d-flex" style="align-items: center;">
          <button
            class="btn btn-danger btn-sm mr-1"
            style="color: white;"
            v-if="
              Category.productCount === 0 && Category.hasDescendants === false
            "
            @click="deleteCategory(Category.categoryID)"
          >
            x
          </button>
          <button
            class="btn btn-success btn-sm"
            :disabled="Loading"
            @click="showProductsInCategory(Category)"
          >
            ⇒
          </button>
          <p
            class="ml-1 mb-0"
            style="color: #3782f3; text-decoration: underline; cursor: pointer;"
            @click="goInsideCategory(Category)"
          >
            {{ Category.label }} ({{ Category.productCount }})
          </p>
        </div>
        <p>{{ Category.notes }}</p>
      </div>
    </div>
    <!-- /Results -->
  </div>
</template>

<script>
export default {
  name: "CategoriesSidepanel",
  props: ["reference"],
  data() {
    return {
      NewCategory: "",
      Notes: "",
      ParentHID: null,
      CurrentHID: "/",
      CurrentCategory: "All categories",
      CurrentCategoryID: null,
      Level: 0,
    };
  },
  computed: {
    getCategoryResults() {
      return this.$store.getters["categories/getCategoryResults"];
    },
    getCategoryData() {
      return this.$store.getters["categories/getCategoryData"];
    },
    Fetching() {
      return this.$store.getters["categories/sidepanelFetchingState"];
    },
    PageNumber() {
      return this.$store.state.categories.pageNumber;
    },
    Loading() {
      return this.$store.state.categories.mainpanelFetching;
    },
  },
  methods: {
    rebuildCategories() {
      this.$store
        .dispatch("categories/rebuildCategoryCache", {
          clientID: 0,
        })
        .then((data) => {
          const message = data.split(".")[0];
          alert(message);
        });
    },
    goInsideCategory(Category) {
      window.scroll(0, 0);
      if (this.Fetching === true) {
        return;
      }
      this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", true);

      // update new information
      this.CurrentCategory = Category.label;
      this.CurrentCategoryID = Category.categoryID;
      this.CurrentHID = Category.hid;

      // fetch new information
      this.$store
        .dispatch("categories/getCategory", {
          categoryID: this.CurrentHID,
        })
        .then(() => {
          this.Level++;
          this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", false);
          this.ParentHID = this.getCategoryData.parentHID;

          this.$store.commit(
            "categories/SET_CURRENT_CATEGORY_ID",
            this.getCategoryData.categoryID
          );
          this.$store.commit(
            "categories/SET_RENAME_CATEGORY_HID",
            this.getCategoryData.hid
          );
        });
    },
    goToLastCategory() {
      if (this.Fetching === true) {
        return;
      }

      this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", true);
      // api call
      this.$store
        .dispatch("categories/getCategory", {
          categoryID: this.getCategoryData.parentHID,
        })
        .then(() => {
          this.Level--;
          this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", false);
          this.ParentHID = this.getCategoryData.parentHID;
          this.CurrentHID = this.getCategoryData.hid;

          this.$store.commit(
            "categories/SET_CURRENT_CATEGORY_ID",
            this.getCategoryData.categoryID
          );
          this.$store.commit(
            "categories/SET_RENAME_CATEGORY_HID",
            this.getCategoryData.hid
          );
        });
    },
    AddCategory() {
      // checks
      if (this.NewCategory === "") return;

      // clearing inputs
      let NewCategory = this.NewCategory;
      let Notes = this.Notes;
      this.NewCategory = "";
      this.Notes = "";

      // payload + api call
      const payload = {
        parentHID: this.CurrentHID,
        label: NewCategory,
        notes: Notes,
      };
      // console.log(payload);
      this.$store.dispatch("categories/addCategory", payload).then(() => {
        this.updateData();
      });
    },
    deleteCategory(CategoryID) {
      const confirmation = confirm(
        "Are you sure you want to delete selected category?"
      );
      if (!confirmation) {
        return;
      }
      this.$store
        .dispatch("categories/deleteCategoryByID", {
          categoryID: CategoryID,
        })
        .then(() => {
          this.updateData();
        });
    },
    showProductsInCategory(Category) {
      // console.log(Category);
      window.scroll(0, 0);
      this.$store.commit("categories/SET_PAGE_NUMBER", 1);
      this.$store.commit("categories/SET_PRODUCT_SEARCH_TERM", "");
      // this.$store.commit(
      //   "categories/SET_CURRENT_CATEGORY_ID",
      //   Category.categoryID
      // );
      this.$store.commit("categories/SET_CURRENT_CATEGORY_HID", Category.hid);
      try {
        this.reference.mainview.updateData();
        this.$store.commit("categories/SET_HEADING_LABEL", Category.label);
      } catch (error) {
        console.log(error);
      }
    },
    updateData() {
      // console.log(this.CurrentHID);
      this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", true);
      this.$store
        .dispatch("categories/getCategory", {
          categoryID: this.CurrentHID,
        })
        .then(() => {
          this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", false);
        });
    },
  },
  created() {
    this.updateData();
    this.$store.commit(
      "categories/SET_CURRENT_CATEGORY_HID",
      this.getCategoryData.hid
    );
    this.$store.commit(
      "categories/SET_CURRENT_CATEGORY_ID",
      this.getCategoryData.categoryID
    );
  },
};
</script>

<style></style>
